// @ts-nocheck
import React, { FC } from 'react';
import { Props } from '@lib/constants';

import { AppTemplate } from '@components/4-templates';
import { Spacer } from '@components/1-atoms';
import { AccountType, IncomeStatamentHeader } from '@components/3-organisms';
import { withForwardedNavigationParams } from 'react-navigation-props-mapper';
import { useStatementProfitAndLoss } from '@lib/hooks/useStatement';

import * as utils from '@lib/utils';
import Sandwich from '@assets/icons/sandwich';

import {
  Header,
  IconButton
} from '@components/2-molecules';

const StatementIncome: FC<Props> = ({ navigation, ...props }) => {

    const dateRange = utils.getMonthToDate(new Date());
    const data = {
        startDate: dateRange[0],
        endDate: dateRange[1]
    };
    const [profitAndLoss,] = useStatementProfitAndLoss({ data: data });

    const AccountTypes = profitAndLoss?.data.length && profitAndLoss.data.map((accountType) => {
        return (<AccountType data={accountType} />);
    });

    console.log(profitAndLoss?.data);

    return (
        <AppTemplate hooks={[profitAndLoss]}>

            <Header
                title={"PROFIT & LOSS"}
                left={<IconButton icon={<Sandwich />} onPress={navigation?.toggleDrawer} />}
            />
            <Spacer h={1} />
            
            <IncomeStatamentHeader startDate={dateRange[0]} endDate={dateRange[1]} />
            <Spacer h={1.5} />

            {AccountTypes || null}

            <Spacer h={2} />
        </AppTemplate>
    );
};


export default withForwardedNavigationParams<Props>()(StatementIncome);